/**
 * Onglets du détail d'une expérience (brief `experiences.md` : Summary, Runs, Permissions) et du
 * détail d'un run (brief `experience-run-detail.md`). L'onglet actif vit dans l'URL (`?tab=`).
 * La liste des runs vient en premier : c'est ce qu'on ouvre une expérience pour voir.
 */
export const EXPERIMENT_TABS = ['runs', 'summary', 'definition', 'permissions'] as const;
export type ExperimentTab = (typeof EXPERIMENT_TABS)[number];

export const isExperimentTab = (value: unknown): value is ExperimentTab =>
  typeof value === 'string' && (EXPERIMENT_TABS as readonly string[]).includes(value);

export const RUN_TABS = ['metrics', 'params', 'summary'] as const;
export type ExperimentRunTab = (typeof RUN_TABS)[number];

export const isExperimentRunTab = (value: unknown): value is ExperimentRunTab =>
  typeof value === 'string' && (RUN_TABS as readonly string[]).includes(value);
